import { render, staticRenderFns } from "./OzTextLink.vue?vue&type=template&id=5a404759&"
import script from "./OzTextLink.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzTextLink.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports